const inactivateEquipments = {
  toastr: 'Updated equipments',
  toastr1: 'Equipments INACTIVATED successfully',
  toastr2: 'Equipments REACTIVATED successfully',
};

export default inactivateEquipments;
